export default __webpack_public_path__ + "static/media/8.6de2a3c5.svg";